<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Header - Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t("campaigns.title") }}</span>
        <h3 class="page-title">{{ $t("campaigns.sub") }}</h3>
      </d-col>
    </d-row>

    <!-- New Campaign Button -->
    <d-row sm="4" class="d-flex align-items-start mb-4">
      <d-link to="/new-campaign">
        <d-button
          :disabled="disableNewCampaignButton"
          size="md"
          class="btn btn-accent outline mt-2 ml-3 btn-primary btn-padding-fix"
        >
          <i class="material-icons">&#XE145;</i>
          {{ $t("campaigns.createnew") }}
        </d-button>
      </d-link>
    </d-row>

    <!-- Small Stats Blocks -->
    <div v-if="!isCampaignLoading">
      <d-row>
        <d-col v-for="(campaign, idx) in formattedCampaigns" :key="idx" md="6" lg="3" class="mb-4">
          <div @click="navigateTo(campaign)" style="cursor: pointer;">
            <small-stats
              :id="`small-stats-${idx}`"
              :label="campaign.name"
              :value="campaign.contacts.length"
              :percentage="campaign.percentage"
              :increase="campaign.increase"
              :decrease="campaign.decrease"
              :openRate="campaign.stats.opened * 100.0"
              :clickRate="campaign.stats.clicked * 100.0"
              :sentPercentage="campaign.stats.sent * 100.0"
              :showCampaignStats="showCampaignStats"
            ></small-stats>
          </div>
        </d-col>
      </d-row>
    </div>
    <div v-else>Loading...</div>
  </d-container>
</template>

<script>
import SmallStats from "@/components/common/SmallStats.vue";

import colors from "@/utils/colors";

import { mapGetters } from "vuex";
import { CAMPAIGN_GET_LIST, CAMPAIGN_GET } from "@/store/types";

export default {
  name: "campaigns",
  components: {
    SmallStats
  },
  mounted() {
    this.$store.dispatch(CAMPAIGN_GET_LIST).then(resp => {
      console.log(resp);
    });
  },
  data() {
    return {
      dateRange: {
        from: null,
        to: null
      },
      showCampaignStats: true
    };
  },
  methods: {
    navigateTo(campaign) {
      this.$store.commit(CAMPAIGN_GET, campaign._id);
      this.$router.push({
        name: "campaign-prospects",
        params: { id: campaign._id }
      });
    }
  },
  computed: {
    ...mapGetters(["getCampaigns", "isCampaignLoading", "getCurrentUser"]),
    // Small Stats Components Data
    formattedCampaigns() {
      if (this.getCampaigns && this.getCampaigns.length > 0) {
        return this.getCampaigns.map(campaign => {
          campaign.datasets = [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: colors.primary.toRGBA(0.1),
              borderColor: colors.primary.toRGBA(),
              data: [9, 3, 3, 9, 9]
            }
          ];
          return campaign;
        });
      }
      return [];
    },
    disableNewCampaignButton() {
      return (
        !this.getCurrentUser ||
        (!!this.getCurrentUser.trialUsed && !this.getCurrentUser.premium)
      );
    }
  }
};
</script>